export const getKeyByValue = (object: Object, roleConstantValue: any) => {
  for (const [key, value] of Object.entries(object)) {
    if (value === roleConstantValue) {
      return key;
    }
  }
};
